import { isNotNull, or } from "@-/com.npmjs.drizzle-orm";
import { useMutation } from "@-/com.npmjs.tanstack__react-query";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { ActorDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.actor";
import { actorSchema } from "@-/dev.improve.haniverse.database.schemas.actor.schema";

export function useClearActorDeck() {
  const [actorDb] = useContextSelectors(ActorDatabaseContext, (c) => c.db);

  return useMutation({
    mutationFn: async (): Promise<void> => {
      await actorDb(import.meta.location).transaction(async (tx) => {
        // Detach before retiring schedules. Keep parent rows as tombstones so a
        // device uploading an older review can still satisfy its foreign keys.
        // One transaction also prevents auto-upload from seeing half a reset.
        await tx
          .update(actorSchema.userCard)
          .set({ fsrsCardId: null, manuallyMasteredAt: null, startedStudyingAt: null })
          .where(
            or(
              isNotNull(actorSchema.userCard.fsrsCardId),
              isNotNull(actorSchema.userCard.manuallyMasteredAt),
              isNotNull(actorSchema.userCard.startedStudyingAt),
            ),
          );
        await tx.softDelete(actorSchema.userCardReview).where(undefined);
        await tx.softDelete(actorSchema.fsrsCardReviewLog).where(undefined);
        await tx.softDelete(actorSchema.fsrsCard).where(undefined);
      });
    },
    mutationKey: ["clearActorDeck"],
  });
}
